import { render } from "./Utenti.vue?vue&type=template&id=a82e2286"
import script from "./Utenti.vue?vue&type=script&lang=js"
export * from "./Utenti.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francescoscialacqua/Sviluppo/emmet.client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__